const initialState = {
  sectorList: [],
  sectorNamesList: [],
  loadingSectors: false
};

export function sectorReducer(state = initialState, action) {
  switch (action.type) {
    case 'GETSECTOR':
      return { ...state, sectorList: action.sectors };
    case 'SECTOR_NAMES_LIST_GET':
      return { ...state, sectorNamesList: action.sectorNamesList };
    case 'LOADING_SECTORS_START':
      return {
        ...state,
        loadingTags: true
      };
    case 'LOADING_SECTORS_FINISH':
      return {
        ...state,
        loadingTags: false
      };
    default:
      return state;
  }
}
